import { createDivElement } from '@mbrtargeting/metatag-utils';

/**
 * The HTMLElements that are created for an adslot.
 *
 * ```
 * (slotElement - provided by publisher)
 *  |__ containerNode
 *     |__ slotHull
 *        |__ loadingSpinner
 *        |__ advertLabel
 *        |__ adserverAnchor
 *           |__ adserverContainer
 * ```
 */
export interface AdslotHTMLElements {
    containerNode: HTMLElement;
    slotHull: HTMLElement;
    loadingSpinner: HTMLElement;
    advertLabel: HTMLElement;
    adserverAnchor: HTMLElement;
    adserverContainer: HTMLElement;
}

/**
 * Creates and returns a set of HTML elements required for an ad slot.
 *
 * @param params.slotName The slotName of the adslot.
 * @returns An object containing the HTML elements for the Adslot.
 */
export const createAdslotHTMLElements = ({ slotName }: { slotName: string }): AdslotHTMLElements => {

    const containerNode: HTMLElement = createDivElement({ id: `sdgSlotContainer-${slotName}`, classList: ['sdgSlotContainer', `sdgSlotName-${slotName}`] });
    const slotHull: HTMLElement = createDivElement({ id: `sdgSlotHull-${slotName}`, classList: ['sdgSlotHull'] });
    const loadingSpinner: HTMLElement = createDivElement({ id: `sdgLoadingSpinner-${slotName}`, classList: ['sdgSpinner', 'sdgRemoved'] });
    const advertLabel: HTMLElement = createDivElement({ id: `sdg_${slotName}_anz`, classList: ['sdgAnzeigenkennung', `sdgAnz-${slotName}`, 'sdgRemoved'] });
    const adserverAnchor: HTMLElement = createDivElement({ id: `sdgAdServerAnchor-${slotName}`, classList: ['sdgAdServerAnchor'] });
    const adserverContainer: HTMLElement = createDivElement({ id: `sdgAdServerContainer-${slotName}` });

    adserverAnchor.appendChild(adserverContainer);
    slotHull.appendChild(loadingSpinner);
    slotHull.appendChild(advertLabel);
    slotHull.appendChild(adserverAnchor);
    containerNode.appendChild(slotHull);

    return {
        containerNode,
        slotHull,
        loadingSpinner,
        advertLabel,
        adserverAnchor,
        adserverContainer,
    }
}
